import {useContext, useReducer} from 'react'
import {useNavigate} from 'react-router-dom'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes} from '@s-ui/react-atom-button'
import AtomValidationText, {AtomValidationTextTypes} from '@s-ui/react-atom-validation-text'
import Context from '@s-ui/react-context'
import {FormTechnicalMake} from '@adv-mt/mt-form-make'
import {FormTechnicalModel} from '@adv-mt/mt-form-model'

import {BASE_CLASS, LOW_DASH, SPACE_STRING} from '../settings.js'
import {actions, reducer, reducerInitialState} from './reducer.js'

const transformToUrl = string => string && string.toLocaleLowerCase().replaceAll(SPACE_STRING, LOW_DASH)

export const MakeModelSelector = ({pageName}) => {
  const navigate = useNavigate()
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {MAKES_SIZES_DISTRIBUTOR_PAGE_NAME, DISTRIBUTOR_PAGE_CONFIG: pageConfig} = config.get('page')
  const [state, dispatch] = useReducer(reducer, reducerInitialState)
  const isMakesSizesPage = pageName === MAKES_SIZES_DISTRIBUTOR_PAGE_NAME

  const handleChangeMake = ({value}) => {
    if (value.id === 0) {
      return dispatch({type: actions.SET_MAKE, payload: null})
    }
    dispatch({type: actions.SET_MAKE, payload: value})
  }

  const handleChangeModel = ({value}) => {
    if (value.id === 0) {
      return dispatch({type: actions.SET_MODEL, payload: null})
    }
    dispatch({type: actions.SET_MODEL, payload: value})
  }

  const _handleSearch = () => {
    if (!state.make) {
      dispatch({type: actions.SET_MAKE_FORM_ERRORS, payload: true})
      return
    }
    if (isMakesSizesPage && !state.model) {
      dispatch({type: actions.SET_MODEL_FORM_ERRORS, payload: true})
      return
    }
    const makeUrlFormated = transformToUrl(state.make.name)
    const modelUrlFormated = transformToUrl(state.model?.name)

    let url = pageConfig[pageName].nextPagePattern.concat(`${makeUrlFormated}/`)

    if (!modelUrlFormated) {
      return (window.location.href = url)
    } else {
      url = url.concat(`${modelUrlFormated}/`)
    }
    navigate(url)
  }

  return (
    <div className={`${BASE_CLASS}Filters`}>
      <div className={`${BASE_CLASS}FormMake`}>
        <FormTechnicalMake
          initialSearch={state.initialMakeModelSearch}
          hasErrors={state.hasMakeFormErrors}
          pageName={pageName}
          onChange={(_, filterProps) => handleChangeMake({...filterProps})}
          value={state.make?.id}
        />
        {state.hasMakeFormErrors && (
          <div className={`${BASE_CLASS}FormMakeErrors`}>
            <AtomValidationText text={i18n.t('DISTRIBUTOR.NO_MAKE_SELECTED')} type={AtomValidationTextTypes.ERROR} />
          </div>
        )}
      </div>
      <div className={`${BASE_CLASS}FormModel`}>
        <FormTechnicalModel
          initialSearch={state.initialMakeModelSearch}
          hasErrors={state.hasModelFormErrors}
          pageName={pageName}
          onChange={(_, filterProps) => handleChangeModel({...filterProps})}
          value={{id: state.model?.id}}
        />
        {state.hasModelFormErrors && (
          <div className={`${BASE_CLASS}FormModelErrors`}>
            <AtomValidationText text={i18n.t('DISTRIBUTOR.NO_MODEL_SELECTED')} type={AtomValidationTextTypes.ERROR} />
          </div>
        )}
      </div>
      <div className={`${BASE_CLASS}FormButton`}>
        <AtomButton shape={atomButtonShapes.CIRCULAR} fullWidth onClick={_handleSearch}>
          {i18n.t('NAVIGATION_MAIN_SEARCH_TITLE')}
        </AtomButton>
      </div>
    </div>
  )
}

MakeModelSelector.displayName = 'MakeModelSelector'

MakeModelSelector.propTypes = {
  pageName: PropTypes.string
}
